import { Avatar, Button, List } from 'antd';
import { useState } from 'react';
import { CheckCircleOutlined, UserOutlined } from '@ant-design/icons';
import Modal from 'react-modal';
import { IParticipantForUser, IPartyForUser, TUserId } from '../../PartyClientResponse';
import { ZINDEX_MODAL } from './AppConstants';
import { useAppState } from '../../state/AppState';
import firebase from 'firebase/app';

const InviteUserModal = ({
  isOpen,
  onRequestClose,
  participants,
  user,
}: {
  isOpen: boolean;
  onRequestClose: () => void;
  participants: IParticipantForUser[];
  party: IPartyForUser;
  user: firebase.User | null;
}) => {
  const { inviteParticipantToArea, currentArea } = useAppState();
  const [searchValue] = useState('');
  const [invited, setInvited] = useState<Partial<{ [key: string]: boolean }>>({});
  const filteredParticipants = participants.filter(
    (p) => p.uid !== user?.uid && p.displayName.toLowerCase().includes(searchValue.toLowerCase())
  );
  if (!user) {
    return <div />;
  }
  return (
    <Modal
      ariaHideApp={false}
      isOpen={isOpen}
      onRequestClose={(e) => {
        e.stopPropagation();
        onRequestClose();
      }}
      style={{
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          background: 'white',
          border: 'none',
        },
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.75)',
          zIndex: ZINDEX_MODAL,
        },
      }}>
      <div style={{ maxHeight: 400, minWidth: 400, overflowY: 'scroll' }}>
        <h3>
          <UserOutlined style={{ marginRight: '0.5em' }} />
          People
        </h3>
        <List
          size='small'
          dataSource={filteredParticipants}
          locale={{ emptyText: 'No dancers found' }}
          renderItem={(participant: IParticipantForUser) => (
            <List.Item
              actions={[
                invited[participant.uid] ? (
                  'invited!'
                ) : currentArea === participant.currentArea ? (
                  'aleady here'
                ) : (
                  <Button
                    style={{ color: 'black' }}
                    onClick={async (e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setInvited((invited) => ({ ...invited, [participant.uid]: true }));
                      await inviteParticipantToArea(participant.uid as TUserId);
                    }}>
                    Invite to room
                  </Button>
                ),
              ]}>
              <List.Item.Meta
                avatar={<Avatar src={participant.photoURL} size='small' />}
                title={participant.displayName}
              />
            </List.Item>
          )}
        />
        <div style={{ marginTop: '1em' }}>
          <Button
            style={{ color: 'black' }}
            type='text'
            icon={<CheckCircleOutlined />}
            onClick={() => {
              onRequestClose();
            }}>
            OK
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default InviteUserModal;
